export default {

  SSO_PROFESSORES_JALEKO: { nome: 'sso-professores-jaleko' },
  PERFIL_MEUS_TUTORES: { nome: 'perfil-meus-tutores' },
  HEADER_CURSOS: { nome: 'header-cursos' },
  HEADER_JALEKLINICO: { nome: 'header-jaleklinico' },
  HEADER_FLASHCARDS: { nome: 'header-flashcards' },
  HEADER_SIMULADOS: { nome: 'header-simulados' },
  HEADER_ARTIGOS: { nome: 'header-artigos' },
  HEADER_LIVES: { nome: 'header-lives' },
  HEADER_RECURSOS_EXTRA: { nome: 'header-recursos-extra' },
  HEADER_EXECUCAO_DECK_BOTAO_VOLTAR : { nome: 'header-execucao-deck-botao-voltar' },
  HEADER_ARTMED360: { nome: 'header-artmed360' },
  HEADER_FERRAMENTAS: { nome: 'header-ferramentas' },
  HEADER_BIBLIOTECA_A: { nome: 'header-biblioteca-a' },
  HEADER_GRUPO_VITA_PART: { nome: 'header-grupo-vita-part' },
  TERMO_USO_VISUALIZACAO_MODAL: { nome: 'termo-uso-visualizacao-modal' },
  HOME_CATEGORIAS: { nome: 'home-categorias' },
  HOME_DISCIPLINAS: { nome: 'home-disciplinas' },
  HOME_SISTEMAS: { nome: 'home-sistemas' },
  HOME_VIDEOS: { nome: 'home-videos' },
  DADOS_ACADEMICOS_MEUS_DADOS: { nome: 'dados-academicos-meus-dados' },
  SALA_DE_AULA_TIRE_SUAS_DUVIDAS: { nome: 'sala-de-aula-tire-suas-duvidas' },
  SALA_DE_AULA_TOPICO_EXPERIENCIA_IMERSIVA: { nome: 'sala-de-aula-topico-experiencia-imersiva' },
  SALA_DE_AULA_FLASHCARDS: { nome: 'sala-de-aula-flashcards' },
  PERFIL_MEUS_DADOS_ACADEMICOS: { nome: 'perfil-meus-dados-academicos' },
  CURSO_DATA_EXPIRACAO: { nome: 'curso-data-expiracao' }

}
